import { combineEpics } from 'redux-observable';
import checkAuthTokenExpirationEpic from 'redux/epic/auth';

const rootEpic = combineEpics(checkAuthTokenExpirationEpic);

export default rootEpic;
